/* eslint-disable no-nested-ternary */
import React, { useEffect, useState, useRef } from "react";
import { useSpring, animated } from "@react-spring/web";
import { useDevice } from "design_system/src";

interface VideoAnimationProps {
  children: React.ReactNode;
}

const VideoAnimation: React.FC<VideoAnimationProps> = ({ children }) => {
  const { isMobile: isMobileDevice, isLoading } = useDevice();
  const [isMobile, setIsMobile] = useState<boolean>();
  const [height, setHeight] = useState<number>(0);
  const [progress, setProgress] = useState<number>(0);

  const videoSectionRef = useRef<HTMLDivElement>(null);
  const videoBottomRef = useRef<HTMLDivElement>(null);

  const handleScroll = () => {
    const rect = videoSectionRef.current!.getBoundingClientRect();
    const top = Math.round(rect.top + window.scrollY);

    const scrollBottom = window.scrollY + window.innerHeight;
    const containerHeight = videoSectionRef.current!.offsetHeight * 2;
    const containerBottom = top + videoSectionRef.current!.offsetHeight;

    const rawProgress = (scrollBottom - containerBottom) / containerHeight;
    const newProgress = Math.min(1, Math.max(0, rawProgress));
    const newHeight = containerHeight * newProgress;

    setHeight(newHeight);
    setProgress(newProgress);
  };

  useEffect(() => {
    if (!isLoading) {
      setIsMobile(isMobileDevice);
    }
  }, [isMobileDevice, isLoading]);

  // eslint-disable-next-line consistent-return
  useEffect(() => {
    if (videoSectionRef.current != null && videoBottomRef.current != null && !isMobile) {
      window.addEventListener("scroll", handleScroll);
      return () => window.removeEventListener("scroll", handleScroll);
    }
  }, [videoSectionRef, isMobile]);

  const videoSpring = useSpring({
    width: `${progress > 0.7 ? 100 : 80}%`,
    height: `${progress > 0.7 ? 450 : 400}px`,
    transform: `translate(${
      progress > 0.7 ? 50 : 0
    }%, ${
      progress >= 1 ? 450 * progress : progress > 0.7 ? 350 * progress : progress > 0.4 ? 200 * progress : 0
    }px)`,
    config: { tension: 170, friction: 26 },
  });

  return (
    <>
      {isMobile === undefined && <div/>}
      {isMobile !== undefined && isMobile && <div className="w_100_per h_400_px">{children}</div>}
      {isMobile !== undefined && !isMobile && <div className="pos_relative">
        <div ref={videoSectionRef} className="w_100_per h_300_px">
          <animated.div
            style={{
              ...videoSpring,
            }}
            className="pos_absolute"
          >{children}</animated.div>
        </div>
        <div ref={videoBottomRef} style={{ height: `${height}px` }}/>
      </div>}
    </>
  );
};

export default VideoAnimation;
